import { Component, Input } from '@angular/core';

import { CommonModule } from '@angular/common';

@Component({
	standalone: true,
	selector: 'sgp-message-feedback',
	templateUrl: './message-feedback.component.html',
	imports: [CommonModule]
})
export class MessageFeedbackComponent {
	@Input() show = false;
	@Input() tipo: 'danger' | 'success' | 'warning' | 'info' = 'danger';
	@Input() mensagem = '';

	icones = new Map();

	constructor() {
		this.icones.set('danger', 'fas fa-times-circle');
		this.icones.set('success', 'fas fa-check-circle');
		this.icones.set('warning', 'fas fa-exclamation-triangle');
		this.icones.set('info', 'fas fa-info-circle');
	}

	getTipo(): string {
		return 'feedback ' + this.tipo;
	}

	getIcone(): string {
		return this.icones.get(this.tipo);
	}
}
